import { Phone, MessageCircle, Navigation } from "lucide-react";
import { BRAND } from "../data/content";
import { track } from "../lib/tracking";

export const MobileBar = () => (
  <nav
    data-testid="mobile-conversion-bar"
    className="fixed inset-x-0 bottom-0 z-[60] grid grid-cols-3 border-t border-gold/25 bg-obsidian/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl md:hidden"
    aria-label="Quick actions"
  >
    <a
      href={BRAND.phonePrimaryHref}
      data-testid="mobilebar-call-btn"
      onClick={() => track("call_click", { placement: "mobile_bar" })}
      className="flex flex-col items-center gap-1 py-3 text-ivory transition-colors duration-300 active:text-gold"
    >
      <Phone size={19} className="text-gold" />
      <span className="text-[10px] font-bold uppercase tracking-[0.2em]">Call</span>
    </a>
    <a
      href={BRAND.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobilebar-whatsapp-btn"
      onClick={() => track("whatsapp_click", { placement: "mobile_bar" })}
      className="flex flex-col items-center gap-1 border-x border-white/5 bg-gold py-3 text-obsidian"
    >
      <MessageCircle size={19} />
      <span className="text-[10px] font-bold uppercase tracking-[0.2em]">WhatsApp</span>
    </a>
    <a
      href={BRAND.directions}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobilebar-directions-btn"
      onClick={() => track("directions_click", { placement: "mobile_bar" })}
      className="flex flex-col items-center gap-1 py-3 text-ivory transition-colors duration-300 active:text-gold"
    >
      <Navigation size={19} className="text-gold" />
      <span className="text-[10px] font-bold uppercase tracking-[0.2em]">Directions</span>
    </a>
  </nav>
);
